import { render, staticRenderFns } from "./ArticleGrid.vue?vue&type=template&id=53f5d00d&"
import script from "./ArticleGrid.vue?vue&type=script&lang=js&"
export * from "./ArticleGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports